module.exports = __webpack_public_path__ + "media/images/relationships-segment-f39f2b4d903d702ca485d58c4f333a9a.jpg";